import { createSelector } from 'reselect';

export const couponsSelector = createSelector(
  (state) => state.coupons,
  (coupons) => (
    _.orderBy(coupons, ['active', 'updated_at'], ['desc', 'desc'])
  )
);
